import { createSlice } from "@reduxjs/toolkit";
import { Account } from "../../@types/account";
import findAccounts from "./actions/findAccounts";

interface initialStateInterface {
  accounts: Account[];
  findStatus: string;
}

const initialState = {
  accounts: [],
  findStatus: "",
} as initialStateInterface;

const accountSlice = createSlice({
  name: "account",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(findAccounts.pending, (state) => {
      state.findStatus = "pending";
      //state.accounts = [];
    });
    builder.addCase(findAccounts.fulfilled, (state, { payload }) => {
      state.findStatus = "fulfilled";
      state.accounts = payload;
    });
    builder.addCase(findAccounts.rejected, (state) => {
      state.findStatus = "rejected";
      //state.accounts = [];
    });
  },
});

export default accountSlice.reducer;
